import { bootstrapApplication } from "@angular/platform-browser";
import { defineCustomElements } from "@siemens/ix-brand-theme/loader";
import { App } from "./app/app";
import { appConfig } from "./app/app.config";

(async function main() {
  try {
    defineCustomElements(window);
    await bootstrapApplication(App, appConfig);
  } catch (err: unknown) {
    console.error(err);
  }
})();
